import { Component, inject } from '@angular/core';
import { DialogRef } from '@angular/cdk/dialog';
import { VxButtonComponent } from '@ui/button/button.component';
import { VxDialogComponent } from '@ui/dialog/dialog.component';
import { VxDialogFooterComponent } from '@ui/dialog/dialog-footer.component';
import { VxDialogHeaderComponent } from '@ui/dialog/dialog-header.component';
import { SharedModule } from 'src/app/core/shared.module';
import { AlertProcessorSimulationResultViewerComponent } from '../../components/simulation-result-viewer/result-viewer.component';

@Component({
  templateUrl: './simulation-results.component.html',
  imports: [
    SharedModule,
    AlertProcessorSimulationResultViewerComponent,
    VxButtonComponent,
    VxDialogComponent,
    VxDialogFooterComponent,
    VxDialogHeaderComponent,
  ],
  host: { class: 'block w-full' },
})
export class AlertProcessorSimulationResultsDialogComponent {
  private dialogRef = inject(DialogRef);

  protected close(): void {
    this.dialogRef.close();
  }
}
